import { useNavigate } from "react-router";

import { isZendeskMessagingEnabled } from "../../../integrations/zendeskMessaging";
import MobileNavBar from "./mobile";
import { NavbarProps } from "./types";
import WebNavBar from "./web";

const redirectHomePage = (companyType?: string): string => {
  switch (companyType) {
    case "Analytics":
      return "/analytics";
    case "Suporte":
      return "/home/support";
    case "Master":
      return "/home/master";
    default:
      return "/home";
  }
};

const NavBar = (props: NavbarProps) => {
  const navigate = useNavigate();
  const chatEnabled = props.chatEnabled ?? isZendeskMessagingEnabled;
  const chatAvailable = props.chatAvailable ?? true;

  const handleLogoClick = () => {
    props.handleHideNavbar();
    navigate(redirectHomePage(props.companyType));
  };

  const clearCacheAndReload = () => {
    if ("caches" in window) {
      void caches.keys().then((cacheNames) => {
        cacheNames.forEach((cacheName) => {
          void caches.delete(cacheName);
        });
      });
    }

    if ("indexedDB" in window) {
      indexedDB.deleteDatabase("iokPlat");
    }

    document.cookie?.split(";")?.forEach((cookie) => {
      document.cookie = cookie
        .replace(/^ +/, "")
        .replace(/=.*/, `=;expires=${new Date(0).toUTCString()};path=/`);
    });

    navigate("/login");
    window.location.reload();
  };

  const viewProps = {
    ...props,
    chatEnabled: chatEnabled && chatAvailable,
    onLogoClick: handleLogoClick,
    onClearCache: clearCacheAndReload,
  };

  return props.variant === "mobile" ? (
    <MobileNavBar {...viewProps} />
  ) : (
    <WebNavBar {...viewProps} />
  );
};

export type { NavbarProps } from "./types";
export default NavBar;
